<template>
	<section class="promotions background-light main-content align-left">
		<div class="row row-header align-left">
			<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
			<div v-parse-links v-html="content" />
		</div>
		<div class="row promotions-row flex-row slide-row">
			<div v-if="items.length > 4" ref="emblaCarousel" class="embla">
				<div class="embla__container">
					<nuxt-link
						v-for="room in items"
						:key="room.ID"
						:to="localePath(`/${room.filename}`)"
						class="slick-item embla__slide"
					>
						<picture>
							<source
								v-if="room.imageOverviewPortraitWebp"
								:srcset="room.imageOverviewPortraitWebp"
								type="image/webp"
							/>
							<source :srcset="room.imageOverviewPortrait" />
							<img
								loading="lazy"
								:src="room.imageOverviewPortrait"
								:alt="room.imageOverviewPortraitAlt"
							/>
						</picture>
						<div class="slick-slide-content">
							<h3>{{ room.header }}</h3>
							<span>
								{{ button }}
								<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
							</span>
						</div>
					</nuxt-link>
				</div>

				<div class="embla-controls">
					<div class="button-prev" @click="prevSlide">
						<font-awesome-icon icon="fa-light fa-arrow-left-long" size="1x" />
					</div>
					<div class="button-next" @click="nextSlide">
						<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
					</div>
				</div>
			</div>
			<div v-else class="non-carousel-overview">
				<nuxt-link
					v-for="room in items"
					:key="room.ID"
					:to="localePath(`/${room.filename}`)"
					class="slick-item"
				>
					<picture>
						<source
							v-if="room.imageOverviewPortraitWebp"
							:srcset="room.imageOverviewPortraitWebp"
							type="image/webp"
						/>
						<source :srcset="room.imageOverviewPortrait" />
						<img loading="lazy" :src="room.imageOverviewPortrait" :alt="room.imageOverviewPortraitAlt" />
					</picture>
					<div class="slick-slide-content">
						<h3>{{ room.header }}</h3>
						<span>
							{{ button }}
							<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
						</span>
					</div>
				</nuxt-link>
			</div>
		</div>
	</section>
</template>

<script setup>
import emblaCarouselVue from 'embla-carousel-vue';
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	subtitle: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});

const [emblaCarousel, emblaApi] = emblaCarouselVue({ loop: true, duration: 20 });
const selectedScrollSnap = ref(0);

function prevSlide() {
	emblaApi.value.scrollPrev();
}

function nextSlide() {
	emblaApi.value.scrollNext();
}

onMounted(() => {
	if (!emblaApi.value) {
		return;
	}

	emblaApi.value.on('select', () => {
		selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
	});
});
</script>

<style lang="scss" scoped>
.row-header {
	padding: 0 30px 30px;
}

.embla {
	overflow: hidden;
	position: relative;
	width: 100%;
	padding: 0 30px;
}

.non-carousel-overview {
	padding: 0 30px;
	width: 100%;
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
}

.slide-row {
	padding: 0;

	h3 {
		font-size: calc(var(--h3-font-size) - 6px);
	}
}

/* stylelint-disable */
.embla__container {
	display: flex;
}

.embla__slide {
	flex: 0 0 25%;
	min-width: 0;
}
/* stylelint-enable */

.embla-controls {
	div {
		width: 60px;
		height: 60px;
		background: #fff;
		border-radius: 50%;
		cursor: pointer;
		text-align: center;
		line-height: 70px;
		position: absolute;
		top: calc(50% - 90px);
		left: 0;
		z-index: 10;

		&.button-next {
			left: auto;
			right: 0;
		}

		svg {
			font-size: 24px;
			color: #000;
		}
	}
}

/* stylelint-disable */
@media (max-width: 1080px) {
	.embla__slide {
		flex: 0 0 33%;
	}
}

@media (max-width: 920px) {
	.embla__slide {
		flex: 0 0 50%;
	}
}

@media (max-width: 680px) {
	.embla__slide {
		flex: 0 0 100%;
	}
}
/* stylelint-enable */
</style>
